<template>
  <div class="camera-management">
    <div class="camera-management-left">
      <Tree
        @changeSwitch="changeSwitch"
        :switchVal="switchVal"
        @nodeClick="nodeClick"
      ></Tree>
    </div>
    <div class="camera-management-righ">
      <TabelSearch
        :searchConfig="searchConfig"
        :searchParams="searchParams"
        @resetCallBack="resetCallBack"
        @search="setSearchParams"
      ></TabelSearch>
      <Table
        :width="'100%'"
        :tableLoading="tableLoading"
        :tabelButtons="tabelButtons"
        :templateData="tableTemplateData"
        :tableConfig="tableConfig"
        :pagination="pagination"
      >
      </Table>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="title"
      :visible.sync="dialogVisible"
      width="50%"
      :before-close="handleClose"
    >
      <div class="xl-form-tab">
        <div class="xl-form-tab-left">
          <div class="xl-form-tab-label">添加方式</div>
          <el-select
            :disabled="isEdit"
            v-model="activeTab"
            placeholder="请选择添加方式"
            @change="tabClick">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
      </div>

      <div v-show="activeTab === 'IP'">
        <editForm
          ref="editFormIP"
          :formConfig="ipformConfig"
          :ruleForm="ipruleForm"
          :rules="ipRules"
          :buttonConfig="ipbuttonConfig"
        ></editForm>
      </div>
      <div v-show="activeTab === 'Platform'">
        <editForm
          ref="editFormPlat"
          :formConfig="platformformConfig"
          :ruleForm="platformruleForm"
          :rules="platformRules"
          :buttonConfig="platformbuttonConfig"
        ></editForm>
      </div>
    </el-dialog>
    <!-- 批量编辑 -->
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="'批量编辑'"
      :visible.sync="editdialogVisible"
      width="50%"
      :before-close="edithandleClose"
    >
      <editForm
        ref="editForm"
        :formConfig="editformConfig"
        :ruleForm="editruleForm"
        :buttonConfig="editbuttonConfig"
      ></editForm>
    </el-dialog>

    <!-- 生成地址条件 -->
    <el-dialog
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :title="'批量生成地址'"
        :visible.sync="viewUrlDialogVisible"
        width="20%"
        :before-close="viewUrlHandleClose">
        <editForm
            ref="editForm"
            width="100%"
            :formConfig="viewUrlFormConfig"
            :ruleForm="viewUrlRuleForm"
            :buttonConfig="viewUrlButtonConfig"
        ></editForm>
    </el-dialog>
    <el-dialog
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        title="播放地址"
        :visible.sync="viewUrlDialogResultVisible"
        width="80%"
        :before-close="viewUrlResultHandleClose">
        <el-input type="textarea" width="100%" style="width: 100%;max-height: 500px;flex-direction:column;display: flex;" v-model="viewUrlResult" autosize/>
    </el-dialog>
    <!-- 级联资源管理弹出 -->
    <el-dialog
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        title="级联资源管理"
        :visible.sync="jilianDialog"
        width="80%"
        class="jilianContentDialog"
        :before-close="jilianDialogClose">
        <div class="dialogBox">
          <cascade-page :btnOpts="true" :id="cameraId" @closePage="closePage"></cascade-page>
        </div>
    </el-dialog>
  </div>
</template>

<script>
import Tree from "../../../../components/Tree/nodeTree";
import TabelSearch from "../../../../components/tabel-search/tabel-search";
import { cameraApi } from "../../../../api-path/district-api";
import { systemApi } from "../../../../api-path/system-api";
import cascadePage from '../../../../components/cascadePage/cascadePage.vue';
export default {
  name: "allUsers",
  components: {
    Tree,
    TabelSearch,
    cascadePage,
  },
  data() {
    return {
      isEdit: false,
      //批量编辑数据
      editDataList: [],
      //批量获取地址数据
      viewUrlDataList: [],
      //options
      options: [
        {
          value: "IP",
          label: "IP添加",
        },
        {
          value: "Platform",
          label: "平台添加",
        },
      ],
      props: {},
      switchVal: false,
      title: "",
      dialogVisible: false,
      // 搜索条件
      treeAreaId: "",
      treeAreaName: "",
      searchParams: {
        areaId: "",
        // cameraType: '', //设备类型
        monitorType: "", //监控类型
        search: "", //关键词
        type: "", //区域类型  1 公共摄像头 2 区域公共 3 私家
        isDown: false,
        page: 1,
        size: 300,
      },
      searchConfig: {
        dataName: "searchParams",
        items: [
          {
            key: "type",
            valueType: "select",
            placeholder: "选择划分类型",
            option: {
              label: "name",
              value: "id",
            },
            data: [
              {
                name: "公共",
                value: 1,
              },
              {
                name: "区域公共",
                value: 2,
              },
              {
                name: "个人",
                value: 3,
              },
            ],
          },
          {
            key: "monitorType",
            valueType: "select",
            placeholder: "请选择监控类型",
            option: {
              label: "name",
              value: "value",
            },
            data: [
              {
                name: "雪亮监控",
                value: 1,
              },
              {
                name: "社会监控",
                value: 2,
              },
            ],
          },
          {
            key: "search",
            valueType: "text",
            placeholder: "请输入关键词",
          },
        ],
      },
      //表格
      tableLoading: false,
      tableTemplateData: [],
      tabelButtons: [
        {
          type: "add",
          fn: () => {
            this.isEdit = false;
            this.checkAlertInfo();
          },
        },
        {
          type: "edit", //
          title: "批量编辑",
          fn: (data) => {
            this.editDataList = data;
            (this.editruleForm = {
              port: "", //端口
              rtspKey: "", //rtsp模板
              serverKey: "", //流媒体地址
              factoryType: "", //厂家类型
              type: "", //划分类型
              areaId: "", //区域Id
              areaName: "",
            }),
              (this.editdialogVisible = true);
          },
        },
        {
          type: "delete", //删除
          path: cameraApi.deleteCamera,
          paramsName: "ids:id",
          hintMessage: "是否删除所选信息？",
          fn: this.startSearch,
        },
        {
          //模板下载
          type: "download",
          title: "模板下载",
          path: cameraApi.template,
        },
        {
          //模板下载参数说明
          type: "download",
          title: "模板参数下载",
          path: `${cameraApi.templateDesc}/${this.treeAreaId ? this.treeAreaId : "0"}`,
        },
        {
          type: "upload",
          code: "EXPORT",
          accept:
            "application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          // accept:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          path: cameraApi.importCameraSynList, // 请求路径
          fn: () => {
            this.setSearchParams();
          },
        },
        {
          //导出
          type: "download",
          title: "导出",
          path: `${cameraApi.exportCameraSyn}/${this.treeAreaId ? this.treeAreaId : "0"}`,
        },
        {
          //生成地址
          type: JSON.parse(localStorage.getItem("ur")).isAdmin?"viewUrl":"",
          title: "生成地址",
          fn: (data) => {
            this.viewUrlDataList = data;
            this.viewUrlType = 1;
            (this.viewUrlRuleForm = {
              cameraIds: [], //摄像头ID
              netType: 1, //网络类型
              platformKey: "SERVER_RTMP_KEY", //协议类型
              streamType: 1, //流类型
              timeout: new Date().setTime(Date.now() + 3600 * 1000 * 24 * 30), //过期时间
              type: 1, //
            }),
                (this.viewUrlDialogVisible = true);
          },
        },
        {
          //按区域导出地址
          type: JSON.parse(localStorage.getItem("ur")).isAdmin?"areaUrl":"",
          title: "区域生成地址",
          fn: () => {
            this.viewUrlType = 2;
            (this.viewUrlRuleForm = {
              cameraIds: [], //摄像头ID
              netType: 1, //网络类型
              platformKey: "SERVER_RTMP_KEY", //协议类型
              streamType: 1, //流类型
              timeout: new Date().setTime(Date.now() + 3600 * 1000 * 24 * 30), //过期时间
              type: 1, //
            }),
                (this.viewUrlDialogVisible = true);
          },
        },
      ],
      tableConfig: {
        checkbox: true,
        checkboxFn: (data) => {
          console.log(data);
        },
        rows: [
          {
            label: "所属区域",
            prop: "areaName",
          },
          {
            label: "名称",
            prop: "name",
          },
          {
            label: "设备IP",
            prop: "ip",
          },
          {
            label: "地址",
            prop: "address",
            width: "200px",
            type: "popover",
          },
          {
            label: "是否绑定",
            prop: "bindingThird",
            type: "isBind",
            fn: (data) => {
              console.log('data', data)
              this.cameraId = data.id
              this.jilianDialog = true
            }
          },
        ],
        rowButtons: {
          width: "300px",
          items: [
            {
              label: "编辑",
              fn: (data) => {
                this.isEdit = true;
                if (data.means == 1) {
                  this.activeTab = "IP";
                  this.ipruleForm = data;
                } else {
                  this.activeTab = "Platform";
                  this.platformruleForm = data;
                }
                this.dialogVisible = true;
              },
            },
            {
              label: "删除",
              type: "danger",
              fn: (data) => {
                this.$confirm("确认删除改摄像机?", "删除摄像机", {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning",
                })
                  .then(() => {
                    this.$http
                      .post(cameraApi.deleteCamera, {
                        ids: [data.id],
                      })
                      .then((res) => {
                        if (res.status === 200) {
                          this.$message({
                            type: "success",
                            message: "操作成功",
                          });
                          this.setSearchParams();
                        }
                      });
                  })
                  .catch(() => {
                    this.$message({
                      type: "info",
                      message: "已取消操作",
                    });
                  });
              },
            },
          ],
        },
      },
      pagination: {
        show: true,
        total: 0,
        page: 1,
        size: 15,
        sizeChange: this.sizeChange,
        pageChange: this.pageChange,
      }, // 分页
      //弹窗
      //tab切换
      activeTab: "IP", //IP:Platform
      ipruleForm: {
        means: 1,
        //ip添加
        ip: "", //资源名称，
        port: 554, //端口
        account: "admin", //用户名
        password: "", //密码
        channel: 1, //平台添加---通道号
        // 平台添加
        channelId: "", //平台添加---监控编号
        channelSn: "", //平台添加---国际编码
        deviceId: "", //平台添加---终端编号
        // 通用
        areaId: "", //选择区域
        areaName: "", //选择区域名称
        name: "", //名称
        nation: "", //地址名称
        longitude: "", //经度
        latitude: "", //纬度
        rtspKey: "", //rtsp模板
        rtspType: "", //rtsp类型
        factoryType: "", //厂家类型
        cameraType: "", //摄像机类型
        address: "", //地址
        serverKey: "", //流媒体地址
        monitorType: 1, //监控类型
        type: "", //划分类型
      },
      ipRules: {
        ip: [
          {
            required: true,
            trigger: "change",
            message: "请输入IP",
          },
        ],
        port: [
          {
            required: true,
            trigger: "change",
            message: "请输入端口",
          },
        ],
        account: [
          {
            required: true,
            trigger: "change",
            message: "请输入用户名",
          },
        ],
        password: [
          {
            required: true,
            trigger: "change",
            message: "请输入密码",
          },
        ],
        channel: [
          {
            required: true,
            trigger: "change",
            message: "请输入通道号",
          },
        ],
        areaName: [
          {
            required: true,
            trigger: "change",
            message: "请选择区域",
          },
        ],
        name: [
          {
            required: true,
            trigger: "change",
            message: "请输入名称",
          },
        ],
        rtspKey: [
          {
            required: true,
            trigger: "change",
            message: "请选择RTSP模板",
          },
        ],
        serverKey: [
          {
            required: true,
            trigger: "change",
            message: "请选择流媒体地址",
          },
        ],
        type: [
          {
            required: true,
            trigger: "change",
            message: "请选择划分类型",
          },
        ],
        longitude: [
          {
            required: true,
            trigger: "change",
            message: "请绑定经纬度",
          },
        ],
      },
      ipbuttonConfig: {
        buttons: [
          {
            type: "save", // 保存
            loading: false,
            fn: (data) => {
              this.$http.post(cameraApi.saveByIp, data).then((res) => {
                if (res.status === 200) {
                  this.$message({
                    type: "success",
                    message: "操作成功!",
                  });
                  this.dialogVisible = false;
                  this.setSearchParams();
                }
              });
            },
          },
          {
            type: "back", // 重置
            fn: () => {
              this.ipruleForm = {
                means: 1,
                //ip添加
                ip: "", //资源名称，
                port: 554, //端口
                account: "admin", //用户名
                password: "", //密码
                channel: 1, //平台添加---通道号
                // 平台添加
                channelId: "", //平台添加---监控编号
                channelSn: "", //平台添加---国际编码
                deviceId: "", //平台添加---终端编号
                // 通用
                areaId: "", //选择区域
                areaName: "", //选择区域名称
                name: "", //名称
                nation: "", //地址名称
                longitude: "", //经度
                latitude: "", //纬度
                rtspKey: "", //rtsp模板
                rtspType: "", //rtsp类型
                factoryType: "", //厂家类型
                cameraType: "", //摄像机类型
                address: "", //地址
                serverKey: "", //流媒体地址
                monitorType: 1, //监控类型
                type: "2", //划分类型
              };
              this.dialogVisible = false;
            },
          },
        ],
      },
      ipformConfig: {
        disabled: false,
        ref: "editFormIP",
        items: [
          [
            {
              valueType: "input", // 类型
              label: "IP",
              key: "ip", // 数据名称
              prop: "ip", // 验证规则
              labelWidth: "100px", // label 宽度
              maxlength: "50",
              itemWidth: "50%",
              placeholder: "请输入IP", // 提示信息
            },
            {
              valueType: "input", // 类型
              label: "端口",
              key: "port", // 数据名称
              prop: "port", // 验证规则
              labelWidth: "100px", // label 宽度
              itemWidth: "50%",
              placeholder: "请输入端口", // 提示信息
            },
          ],
          [
            {
              valueType: "input", // 类型
              label: "用户名",
              key: "account", // 数据名称
              prop: "account", // 验证规则
              labelWidth: "100px", // label 宽度
              itemWidth: "50%",
              placeholder: "请输入用户名", // 提示信息
            },
            {
              valueType: "input", // 类型
              label: "密码",
              key: "password", // 数据名称
              prop: "password", // 验证规则
              labelWidth: "100px", // label 宽度
              itemWidth: "50%",
              placeholder: "请输入密码", // 提示信息
            },
          ],
          [
            {
              valueType: "tree-selected", // 类型
              label: "选择区域",
              key: "areaName", // 数据名称
              prop: "areaName", // 验证规则
              labelWidth: "100px", // label 宽度
              itemWidth: "50%",
              maxlength: 50,
              disabled: false,
              placeholder: "请选择所属辖区", // 提示信息
              fn: (data) => {
                //选择的值
                this.ipruleForm.areaName = data.name;
                this.ipruleForm.areaId = data.id;
              },
            },
            {
              valueType: "input", // 类型
              label: "名称",
              key: "name", // 数据名称
              prop: "name", // 验证规则
              labelWidth: "100px", // label 宽度
              itemWidth: "50%",
              placeholder: "请输入名称", // 提示信息
            },
          ],
          [
            {
              valueType: "select",
              label: "RTSP模板",
              key: "rtspKey",
              prop: "rtspKey",
              labelWidth: "100px",
              itemWidth: "50%",
              placeholder: "请选择RTSP",
              path: `${cameraApi.rtspList}`,
              options: {
                label: "name",
                value: "rtspKey",
              },
            },
            {
              valueType: "select", // 类型
              label: "流媒体地址",
              key: "serverKey", // 数据名称
              prop: "serverKey", // 验证规则
              labelWidth: "100px", // label 宽度
              itemWidth: "50%",
              placeholder: "请选择流媒体地址", // 提示信息
              path: `${cameraApi.queryList}`,
              options: {
                label: "name",
                value: "platformKey",
              },
            },
          ],
          [
            {
              valueType: "inputNumber", // 类型
              label: "通道号",
              key: "channel", // 数据名称
              prop: "channel", // 验证规则
              labelWidth: "100px", // label 宽度
              maxlength: "50",
              itemWidth: "50%",
              inputWidth: "auto",
              placeholder: "请输入通道号", // 提示信息
            },
            {
              valueType: "nautica", // 类型
              label: "经纬度",
              key: "longitude", // 数据名称
              prop: "longitude", // 验证规则
              labelWidth: "100px", // label 宽度
              itemWidth: "50%",
              maxlength: 30,
              placeholder: "请输入经纬度", // 提示信息
            },
          ],
          [
            {
              valueType: "select",
              label: "厂家类型",
              key: "factoryType",
              prop: "factoryType",
              labelWidth: "100px",
              itemWidth: "50%",
              placeholder: "请选择厂家类型",
              path: `${cameraApi.codeAndItem}?codeValue=code_resource_plantform_type`,
              options: {
                label: "itemName",
                value: "itemValue",
              },
            },
            {
              valueType: "select",
              label: "摄像头类型",
              key: "cameraType",
              prop: "cameraType",
              labelWidth: "100px",
              itemWidth: "50%",
              placeholder: "请选择摄像头类型",
              path: `${cameraApi.codeAndItem}?codeValue=code_monitor_type`,
              options: {
                label: "itemName",
                value: "itemValue",
              },
            },
          ],
          [
            {
              valueType: "select",
              label: "划分类型",
              key: "type",
              prop: "type",
              labelWidth: "100px",
              itemWidth: "50%",
              placeholder: "请选择划分类型",
              data: [
                {
                  label: "公共",
                  value: "1",
                },
                {
                  label: "区域公共",
                  value: "2",
                },
                {
                  label: "家庭/个人",
                  value: "3",
                },
              ],
            },
            {
              valueType: "select",
              label: "监控类型",
              key: "monitorType",
              prop: "monitorType ",
              labelWidth: "100px",
              itemWidth: "50%",
              placeholder: "请选择监控类型",
              data: [
                {
                  label: "雪亮监控",
                  value: 1,
                },
                {
                  label: "社会监控",
                  value: 2,
                },
              ],
            },
          ],
          [
            {
              valueType: "input", // 类型
              label: "监控地址",
              key: "address", // 数据名称
              prop: "address", // 验证规则
              labelWidth: "100px", // label 宽度
              itemWidth: "100%",
              inputWidth: "calc(100% - 100px)",
              placeholder: "请输入地址", // 提示信息
            },
          ],
          [
            {
              valueType: "input", // 类型
              label: "监控编号",
              key: "channelId", // 数据名称
              prop: "channelId", // 验证规则
              labelWidth: "100px", // label 宽度
              itemWidth: "50%",
              placeholder: "请输入监控编号", // 提示信息
            },
            {
              valueType: "input", // 类型
              label: "国际编码",
              key: "channelSn", // 数据名称
              prop: "channelSn", // 验证规则
              labelWidth: "100px", // label 宽度
              itemWidth: "50%",
              placeholder: "请输入国际编码", // 提示信息
            },
          ],
          [
            {
              valueType: "input", // 类型
              label: "终端编号",
              key: "deviceId", // 数据名称
              prop: "deviceId", // 验证规则
              labelWidth: "100px", // label 宽度
              itemWidth: "50%",
              placeholder: "请输入终端编号", // 提示信息
            },
          ],
        ],
      },
      platformruleForm: {
        means: 2,
        //ip添加
        ip: "", //资源名称，
        port: "", //端口
        account: "", //用户名
        password: "", //密码
        channel: 1, //平台添加---通道号
        // 平台添加
        channelId: "", //平台添加---监控编号
        channelSn: "", //平台添加---国际编码
        deviceId: "", //平台添加---终端编号
        // 通用
        areaId: "", //选择区域
        areaName: "", //选择区域名称
        name: "", //名称
        nation: "", //地址名称
        longitude: "", //经度
        latitude: "", //纬度
        rtspKey: "", //rtsp模板
        rtspType: "", //rtsp类型
        factoryType: "", //厂家类型
        cameraType: "", //摄像机类型
        address: "", //地址
        serverKey: "", //流媒体地址
        monitorType: 1, //监控类型
        type: "2", //划分类型
        wvpId:"",
      },
      platformRules: {
        // channel: [{
        // 	required: true,
        // 	trigger:'change',
        // 	message: '请输入通道号',
        // }],
        channelId: [
          {
            required: true,
            trigger: "change",
            message: "请输入监控编号",
          },
        ],
        areaName: [
          {
            required: true,
            trigger: "change",
            message: "请选择区域",
          },
        ],
        name: [
          {
            required: true,
            trigger: "change",
            message: "请输入名称",
          },
        ],
        // rtspKey: [
        //   {
        //     required: true,
        //     trigger: "change",
        //     message: "请选择RTSP模板",
        //   },
        // ],
        // serverKey: [
        //   {
        //     required: true,
        //     trigger: "change",
        //     message: "请选择流媒体地址",
        //   },
        // ],
        type: [
          {
            required: true,
            trigger: "change",
            message: "请选择划分类型",
          },
        ],
        // longitude: [
        //   {
        //     required: true,
        //     trigger: "change",
        //     message: "请绑定经纬度",
        //   },
        // ],
      },
      platformbuttonConfig: {
        buttons: [
          {
            type: "save", // 保存
            loading: false,
            fn: (data) => {
              this.$http.post(cameraApi.saveByIp, data).then((res) => {
                if (res.status === 200) {
                  this.$message({
                    type: "success",
                    message: "操作成功!",
                  });
                  this.dialogVisible = false;
                  this.activeTab = "IP";
                  this.setSearchParams();
                }
              });
            },
          },
          {
            type: "back", // 重置
            fn: () => {
              this.dialogVisible = false;
              this.activeTab = "IP";
            },
          },
        ],
      },
      platformformConfig: {
        disabled: false,
        ref: "editFormPlat",
        items: [
          [
            {
              valueType: "input", // 类型
              label: "监控编号",
              key: "channelId", // 数据名称
              prop: "channelId", // 验证规则
              labelWidth: "100px", // label 宽度
              itemWidth: "50%",
              placeholder: "请输入监控编号", // 提示信息
            },
            {
              valueType: "input", // 类型
              label: "国际编码",
              key: "channelSn", // 数据名称
              prop: "channelSn", // 验证规则
              labelWidth: "100px", // label 宽度
              itemWidth: "50%",
              placeholder: "请输入国际编码", // 提示信息
            },
          ],
          [
            {
              valueType: "tree-selected", // 类型
              label: "选择区域",
              key: "areaName", // 数据名称
              prop: "areaName", // 验证规则
              labelWidth: "100px", // label 宽度
              itemWidth: "50%",
              maxlength: 50,
              disabled: false,
              placeholder: "请选择所属辖区", // 提示信息
              fn: (data) => {
                //选择的值
                this.platformruleForm.areaName = data.name;
                this.platformruleForm.areaId = data.id;
              },
            },
            {
              valueType: "input", // 类型
              label: "名称",
              key: "name", // 数据名称
              prop: "name", // 验证规则
              labelWidth: "100px", // label 宽度
              itemWidth: "50%",
              placeholder: "请输入名称", // 提示信息
            },
          ],
          [
            {
              valueType: "select",
              label: "RTSP模板",
              key: "rtspKey",
              prop: "rtspKey",
              labelWidth: "100px",
              itemWidth: "50%",
              placeholder: "请选择RTSP",
              path: `${cameraApi.rtspList}`,
              options: {
                label: "name",
                value: "rtspKey",
              },
            },
            {
              valueType: "select", // 类型
              label: "流媒体地址",
              key: "serverKey", // 数据名称
              prop: "serverKey", // 验证规则
              labelWidth: "100px", // label 宽度
              itemWidth: "50%",
              placeholder: "请选择流媒体地址", // 提示信息
              path: `${cameraApi.queryList}`,
              options: {
                label: "name",
                value: "platformKey",
              }
            },
          ],
          [
            {
              valueType: "input", // 类型
              label: "终端编号",
              key: "deviceId", // 数据名称
              prop: "deviceId", // 验证规则
              labelWidth: "100px", // label 宽度
              itemWidth: "50%",
              placeholder: "请输入终端编号", // 提示信息
            },
            {
              valueType: "nautica", // 类型
              label: "经纬度",
              key: "longitude", // 数据名称
              prop: "longitude", // 验证规则
              labelWidth: "100px", // label 宽度
              itemWidth: "50%",
              maxlength: 30,
              placeholder: "请输入经纬度", // 提示信息
            },
          ],
          [
            {
              valueType: "select",
              label: "厂家类型",
              key: "factoryType",
              prop: "factoryType",
              labelWidth: "100px",
              itemWidth: "50%",
              placeholder: "请选择厂家类型",
              path: `${cameraApi.codeAndItem}?codeValue=code_resource_plantform_type`,
              options: {
                label: "itemName",
                value: "itemValue",
              },
            },
            {
              valueType: "select",
              label: "摄像头类型",
              key: "cameraType",
              prop: "cameraType",
              labelWidth: "100px",
              itemWidth: "50%",
              placeholder: "请选择摄像头类型",
              path: `${cameraApi.codeAndItem}?codeValue=code_monitor_type`,
              options: {
                label: "itemName",
                value: "itemValue",
              },
            },
          ],
          [
            {
              valueType: "select",
              label: "划分类型",
              key: "type",
              prop: "type",
              labelWidth: "100px",
              itemWidth: "50%",
              placeholder: "请选择划分类型",
              data: [
                {
                  label: "公共",
                  value: "1",
                },
                {
                  label: "区域公共",
                  value: "2",
                },
                {
                  label: "家庭/个人",
                  value: "3",
                },
              ],
            },
            {
              valueType: "select",
              label: "监控类型",
              key: "monitorType",
              prop: "monitorType ",
              labelWidth: "100px",
              itemWidth: "50%",
              placeholder: "请选择监控类型",
              data: [
                {
                  label: "雪亮监控",
                  value: 1,
                },
                {
                  label: "社会监控",
                  value: 2,
                },
              ],
            },
          ],
          [
            {
              valueType: "input", // 类型
              label: "地址",
              key: "address", // 数据名称
              prop: "address", // 验证规则
              labelWidth: "100px", // label 宽度
              itemWidth: "50%",
              // inputWidth: "calc(100% - 100px)",
              placeholder: "请输入地址", // 提示信息
            },
            {
              valueType: "select", // 类型
              label: "国标地址",
              key: "wvpId", // 数据名称
              prop: "wvpId", // 验证规则
              labelWidth: "100px", // label 宽度
              itemWidth: "50%",
              placeholder: "请选择国标地址", // 提示信息
              path: `${systemApi.queryMyList}`,
              options: {
                label: "name",
                value: "id",
              },
              fn:(data,formData) => {
                  formData.means = (data.length > 0)?3:2;
              }
            },
          ],
          [
            {
              valueType: "input", // 类型
              label: "IP",
              key: "ip", // 数据名称
              prop: "ip", // 验证规则
              labelWidth: "100px", // label 宽度
              maxlength: "50",
              itemWidth: "50%",
              placeholder: "请输入IP", // 提示信息
            },
            {
              valueType: "input", // 类型
              label: "端口",
              key: "port", // 数据名称
              prop: "port", // 验证规则
              labelWidth: "100px", // label 宽度
              itemWidth: "50%",
              placeholder: "请输入端口", // 提示信息
            },
          ],
          [
            {
              valueType: "input", // 类型
              label: "用户名",
              key: "account", // 数据名称
              prop: "account", // 验证规则
              labelWidth: "100px", // label 宽度
              itemWidth: "50%",
              placeholder: "请输入用户名", // 提示信息
            },
            {
              valueType: "input", // 类型
              label: "密码",
              key: "password", // 数据名称
              prop: "password", // 验证规则
              labelWidth: "100px", // label 宽度
              itemWidth: "50%",
              placeholder: "请输入密码", // 提示信息
            },
          ],
        ],
      },
      //批量编辑
      editdialogVisible: false,
      editruleForm: {
        port: "", //端口
        rtspKey: "", //rtsp模板
        serverKey: "", //流媒体地址
        factoryType: "", //厂家类型
        type: "", //划分类型
        areaId: "", //区域Id
        areaName: "",
      },
      editbuttonConfig: {
        buttons: [
          {
            type: "save", // 保存
            loading: false,
            fn: (data) => {
              if (
                data.factoryType != "" ||
                data.port != "" ||
                data.rtspKey != "" ||
                data.serverKey != "" ||
                data.type != "" ||
                data.areaId != ""
              ) {
                this.editDataList.map((item) => {
                  if (data.factoryType != "") {
                    item.factoryType = data.factoryType;
                  }
                  if (data.port != "") {
                    item.port = data.port;
                  }
                  if (data.rtspKey != "") {
                    item.rtspKey = data.rtspKey;
                  }
                  if (data.serverKey != "") {
                    item.serverKey = data.serverKey;
                  }
                  if (data.type != "") {
                    item.type = data.type;
                  }
                  if (data.areaId != "") {
                    item.areaId = data.areaId;
                  }
                });
                console.log(this.editDataList);
                this.$http
                  .post(cameraApi.batchUp, {
                    cameras: this.editDataList,
                  })
                  .then((res) => {
                    if (res.status === 200) {
                      this.editdialogVisible = false;
                      this.startSearch();
                    }
                  });
              } else {
                this.$message({
                  type: "warning",
                  message: "请至少修改一项!",
                });
              }
            },
          },
          {
            type: "back", // 重置
            fn: () => {
              this.editdialogVisible = false;
            },
          },
        ],
      },
      editformConfig: {
        disabled: false,
        items: [
          [
            {
              valueType: "input", // 类型
              label: "端口",
              key: "port", // 数据名称
              prop: "port", // 验证规则
              labelWidth: "100px", // label 宽度
              maxlength: "50",
              itemWidth: "50%",
              placeholder: "请输入端口", // 提示信息
            },
            {
              valueType: "tree-selected", // 类型
              label: "选择区域",
              key: "areaName", // 数据名称
              prop: "areaName", // 验证规则
              labelWidth: "100px", // label 宽度
              itemWidth: "50%",
              maxlength: 50,
              disabled: false,
              placeholder: "请选择所属辖区", // 提示信息
              fn: (data) => {
                //选择的值
                this.editruleForm.areaName = data.name;
                this.editruleForm.areaId = data.id;
              },
            },
          ],
          [
            {
              valueType: "select",
              label: "RTSP模板",
              key: "rtspKey",
              prop: "rtspKey",
              labelWidth: "100px",
              itemWidth: "50%",
              placeholder: "请选择RTSP",
              path: `${cameraApi.rtspList}`,
              options: {
                label: "name",
                value: "rtspKey",
              },
            },
            {
              valueType: "select", // 类型
              label: "流媒体地址",
              key: "serverKey", // 数据名称
              prop: "serverKey", // 验证规则
              labelWidth: "100px", // label 宽度
              itemWidth: "50%",
              placeholder: "请选择流媒体地址", // 提示信息
              path: `${cameraApi.queryList}`,
              options: {
                label: "name",
                value: "platformKey",
              },
            },
          ],
          [
            {
              valueType: "select",
              label: "厂家类型",
              key: "factoryType",
              prop: "factoryType",
              labelWidth: "100px",
              itemWidth: "50%",
              placeholder: "请选择厂家类型",
              path: `${cameraApi.codeAndItem}?codeValue=code_resource_plantform_type`,
              options: {
                label: "itemName",
                value: "itemValue",
              },
            },
            {
              valueType: "select",
              label: "划分类型",
              key: "type",
              prop: "type",
              labelWidth: "100px",
              itemWidth: "50%",
              placeholder: "请选择摄像机划分类型",
              data: [
                {
                  label: "公共",
                  value: "1",
                },
                {
                  label: "区域公共",
                  value: "2",
                },
                {
                  label: "家庭/个人",
                  value: "3",
                },
              ],
            },
          ],
        ],
      },
      //批量生成地址
      viewUrlDialogVisible: false,
      viewUrlButtonConfig:{
        buttons: [
          {
            type: "save", //确认
            loading: false,
            fn: (data) => {
              //按监控ID生成地址
              if(this.viewUrlType === 1){
                var cameras = this.viewUrlDataList.map((item) => {
                  return item.id;
                }).join(",");
                window.open(`${cameraApi.exportFindLiveUrl}?cameraIds=${cameras}&streamType=${data.streamType}&platformKey=${data.platformKey}&netType=${data.netType}&timeout=${data.timeout}&type=${data.type}`, '_blank');
                // data.cameraIds =this.viewUrlDataList.map((item) => {
                //   return item.id;
                // });
                // this.$http
                //     .post(cameraApi.findLiveUrl, data)
                //     .then((res) => {
                //       if (res.status === 200) {
                //         this.viewUrlDialogVisible = false;
                //         this.viewUrlDialogResultVisible = true;
                //         this.viewUrlResult = JSON.stringify(res.result,null,'\t');
                //       }
                //     });
              }else{
                //按区域生产地址
                window.open(`${cameraApi.exportFindLiveUrl}/${this.treeAreaId}?streamType=${data.streamType}&platformKey=${data.platformKey}&netType=${data.netType}&timeout=${data.timeout}&type=${data.type}`, '_blank');
                this.viewUrlDialogVisible = false;
              }
            }
          },
          {
            type: "back", // 重置
            fn: () => {
              this.viewUrlDialogVisible = false;
            },
          }
          ]
      },
      viewUrlFormConfig: {
        disabled: false,
        items: [
          [
            {
              valueType: "select",
              label: "协议类型",
              key: "platformKey",
              prop: "platformKey",
              labelWidth: "100px",
              itemWidth: "100%",
              placeholder: "请选择协议类型",
              data: [
                {
                  label: "RTMP协议(默认)",
                  value: "SERVER_RTMP_KEY",
                },
                {
                  label: "RTSP协议",
                  value: "SERVER_RTSP_KEY",
                },
                {
                  label: "HLS协议(m3u8)",
                  value: "SERVER_M3U8_KEY",
                },
              ],
            }
          ],
          [
            {
              valueType: "select",
              label: "网络类型",
              key: "netType",
              prop: "netType",
              labelWidth: "100px",
              itemWidth: "100%",
              placeholder: "请选择网络类型",
              data: [
                {
                  label: "地址1(默认)",
                  value: 1,
                },
                {
                  label: "地址2",
                  value: 2,
                },
                {
                  label: "地址3",
                  value: 3,
                },
                {
                  label: "地址4",
                  value: 4,
                }
              ],
            },
          ],
          [
            {
              valueType: "select",
              label: "码流类型",
              key: "streamType",
              prop: "streamType",
              labelWidth: "100px",
              itemWidth: "100%",
              placeholder: "请选择码流类型",
              data: [
                {
                  label: "码流一(默认)",
                  value: 1,
                },
                {
                  label: "码流二",
                  value: 2,
                }
              ],
            },
          ],[
            {
              valueType: "date",
              label: "过期时间",
              key: "timeout",
              prop: "timeout",
              labelWidth: "100px",
              itemWidth: "100%",
              placeholder: "请选择过期时间",
            },
          ]
        ],
      },
      viewUrlRuleForm: {
        cameraIds: [], //摄像头ID
        netType: 1, //网络类型
        platformKey: "SERVER_RTMP_KEY", //协议类型
        streamType: 1, //流类型
        timeout: new Date().setTime(Date.now() + 3600 * 1000 * 24 * 30), //过期时间
        type: 1, //
      },
      viewUrlResult:"",
      viewUrlDialogResultVisible:false,
      viewUrlType: 1, // 1 按摄像头ID请求   2 按 区域ID请求

      // 级联资源管理
      jilianDialog: false,
      cameraId: '',
    };
  },
  created() {},
  mounted() {
    // this.setSearchParams();
  },
  methods: {
    closePage() {
      this.jilianDialog = false
      this.startSearch()
    },
    jilianDialogClose() {
      this.jilianDialog = false
    },
    tabClick() {},
    clearValidateInfo() {
      this.clearValidate("editFormIP");
      this.clearValidate("editFormPlat");
    },
    // 每页显示条数
    sizeChange(size) {
      this.pagination.size = size;
      this.searchParams.size = size;
      this.startSearch();
    },
    // 当前页
    pageChange(page) {
      this.pagination.page = page;
      this.searchParams.page = page;
      this.startSearch();
    },
    //列表
    startSearch() {
      this.tableLoading = true;
      let params = JSON.parse(JSON.stringify(this.searchParams));
      params.areaId = this.treeAreaId;
      this.$http
        .get(cameraApi.queryListByPage, {
          params: params,
        })
        .then((res) => {
          this.tableLoading = false;
          if (res.status === 200) {
            this.tableTemplateData = res.result.pageList;
            this.pagination.total = res.result.total;
          }
        });
    },
    //新增框显示判断
    checkAlertInfo() {
      this.dialogVisible = true;
      //重置表单
      this.ipruleForm = {
        means: 1,
        //ip添加
        ip: "", //资源名称，
        port: "554", //端口
        account: "admin", //用户名
        password: "", //密码
        channel: 1, //平台添加---通道号
        // 平台添加
        channelId: "", //平台添加---监控编号
        channelSn: "", //平台添加---国际编码
        deviceId: "", //平台添加---终端编号
        // 通用
        areaId: "", //选择区域
        areaName: "", //选择区域名称
        name: "", //名称
        longitude: "", //经度
        latitude: "", //纬度
        rtspKey: "", //rtsp模板
        rtspType: "", //rtsp类型
        factoryType: "", //厂家类型
        cameraType: "", //摄像机类型
        address: "", //地址
        serverKey: "", //流媒体地址
        monitorType: 1, //监控类型
        type: "2", //划分类型
      };
      this.platformruleForm = {
        means: 2,
        //ip添加
        ip: "", //资源名称，
        port: "", //端口
        account: "", //用户名
        password: "", //密码
        channel: 1, //平台添加---通道号
        // 平台添加
        channelId: "", //平台添加---监控编号
        channelSn: "", //平台添加---国际编码
        deviceId: "", //平台添加---终端编号
        // 通用
        areaId: "", //选择区域
        areaName: "", //选择区域名称
        name: "", //名称
        longitude: "0.0", //经度
        latitude: "0.0", //纬度
        rtspKey: "0", //rtsp模板
        rtspType: "0", //rtsp类型
        factoryType: "", //厂家类型
        cameraType: "", //摄像机类型
        address: "", //地址
        serverKey: "0", //流媒体地址
        monitorType: 1, //监控类型
        type: "2", //划分类型
      };
      this.ipruleForm.areaId = this.treeAreaId;
      this.ipruleForm.areaName = this.treeAreaName;
      this.platformruleForm.areaId = this.treeAreaId;
      this.platformruleForm.areaName = this.treeAreaName;
    },
    handleClose() {
      //关闭新增修改用户弹窗
      this.dialogVisible = false;
    },
    edithandleClose() {
      this.editdialogVisible = false;
    },
    viewUrlHandleClose(){
      this.viewUrlDialogVisible = false;
    },
    viewUrlResultHandleClose(){
      this.viewUrlDialogResultVisible = false;
    },
    handleClose3() {
      this.dialogVisible3 = false;
    },
    setSearchParams(value) {
      if (value) {
        this.pagination.page = value.page;
      }
      this.startSearch();
    },
    resetCallBack() {
      (this.searchParams = {
        areaId: "",
        // cameraType: '', //设备类型
        monitorType: "", //监控类型
        search: "", //关键词
        type: "", //区域类型  1 公共摄像头 2 区域公共 3 私家
        page: 1,
        size: 15,
        isDown: this.switchVal,
      }),
        this.setSearchParams();
    },
    changeSwitch(e) {
      this.searchParams.isDown = e;
      this.switchVal = e;
      this.searchParams.page = this.pagination.page = 1;
      this.setSearchParams();
    },
    nodeClick(node) {
      this.tabelButtons[4].path = `${cameraApi.templateDesc}/${node.id ? node.id : "0"}`;
      this.tabelButtons[6].path = `${cameraApi.exportCameraSyn}/${
        node.id ? node.id : "0"
      }`;
      if (node.id !== this.searchParams.areaId) {
        this.treeAreaId = node.id;
        this.treeAreaName = node.id ? node.name : "";
        this.searchParams.areaId = node.id;
        this.searchParams.page = this.pagination.page = 1;
        this.setSearchParams();
      }
    },
  },
};
</script>
<style lang="less">
.camera-management {
  .el-dialog {
      margin-top: 7vh!important;
    }
}

.jilianContentDialog {
  .dialogBox {
    overflow: hidden;
  }
  .components-tabel {
    overflow: auto;
  }
}

</style>
<style lang="less" scoped>
.el-message-box{
  width: 80%;
}



.dialogBox {
  height: 68vh;
}
.camera-management {
  margin-left: 10px;
  box-sizing: border-box;
  height: 100%;
  padding: 10px;
  border-radius: 10px;
  background: #fff;
  display: flex;
  .camera-management-left {
    margin-right: 10px;
    border-right: 1px solid #c1c1c1;
  }

  .camera-management-righ {
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  .xl-form-tab {
    display: flex;
    align-items: center;
    padding-bottom: 10px;
    margin-bottom: 10px;
    border-bottom: 1px solid #ccc;
    justify-content: space-between;
    width: 100%;

    .xl-form-tab-left {
      display: flex;
      align-items: center;

      .xl-form-tab-label {
        margin-right: 20px;
      }
    }
  }
}
</style>
